import { lazy } from "react";

export { default as App } from "./App";
export const Login = lazy(() => import("./Login"));
export const Routes = lazy(() => import("./Routes"));
export const Transactions = lazy(() => import("./Transactions"));
export const Uploader = lazy(() => import("./Uploader"));
export const Profile = lazy(() => import("./Profile"));
